// extracted by mini-css-extract-plugin
export default {"inputVariantContents":"FormError_inputVariantContents__wZ5fu","dialogVariantContents":"FormError_dialogVariantContents__5sO75"};